if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      this.productGallery = this.querySelector("[data-js-product-gallery]");
      this.productSlider = this.querySelector("css-slider");

      this.pickupAvailabilityExtended = this.querySelector(
        "pickup-availability-extended",
      );

      // Gallery thumbnails

      if (this.productSlider) {
        if (this.querySelector(".product-gallery__thumbnails .thumbnail")) {
          this.querySelectorAll(
            ".product-gallery__thumbnails .thumbnail",
          ).forEach((elm, i) => {
            if (i == 0) {
              elm.classList.add("active");
            }
            elm.addEventListener("click", (e) => {
              // Display the selected image
              const selectedIndex = e.currentTarget.dataset.index;
              this.displayGalleryImage(selectedIndex);

              if (this.productSlider.sliderEnabled) {
                this.productSlider.changeSlide(selectedIndex);
              } else {
                // Do not scroll the page when a thumbnail is clicked; only update
                // the active thumbnail and display the large image.
                this.thumbnailNavigationHelper(selectedIndex);
              }
            });
          });

          this.productSlider.addEventListener("change", (e) => {
            this.displayGalleryImage(e.target.index);
            this.thumbnailNavigationHelper(e.target.index);
          });

          // Drag the main image to change it (with loop). This gallery shows one
          // .product-gallery-item at a time, so there's no native scroll to swipe — we
          // detect the gesture and switch the same way a thumbnail click does.
          this.productSlider.style.touchAction = "pan-y"; // keep vertical page scroll
          this.productSlider.addEventListener("dragstart", (e) =>
            e.preventDefault(),
          ); // no ghost image on desktop

          let suppressClick = false;
          const swipeChange = (dx) => {
            const total = this.productGallery.querySelectorAll(
              ".product-gallery-item",
            ).length;
            if (total < 2) return;
            const rtl = document.documentElement.getAttribute("dir") == "rtl";
            const step = (rtl ? dx > 0 : dx < 0) ? 1 : -1; // drag to advance vs go back
            const active = this.querySelector(
              ".product-gallery__thumbnails .thumbnail.active",
            );
            const current = active
              ? parseInt(active.dataset.index)
              : this.productSlider.index || 0;
            this.goToGalleryImage((current + step + total) % total); // wrap = loop
            suppressClick = true; // a real drag must not also open the zoom
          };

          // Touch (mobile): decide direction on the first move; preventDefault horizontal
          // drags so the browser neither scrolls nor fires its swipe-back gesture.
          let tX = 0,
            tY = 0,
            horizontal = null;
          this.productSlider.addEventListener(
            "touchstart",
            (e) => {
              tX = e.touches[0].clientX;
              tY = e.touches[0].clientY;
              horizontal = null;
              suppressClick = false;
            },
            { passive: true },
          );
          this.productSlider.addEventListener(
            "touchmove",
            (e) => {
              const dx = e.touches[0].clientX - tX,
                dy = e.touches[0].clientY - tY;
              if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8))
                horizontal = Math.abs(dx) > Math.abs(dy);
              if (horizontal) e.preventDefault(); // claim the gesture: blocks back-nav + scroll
            },
            { passive: false },
          );
          this.productSlider.addEventListener(
            "touchend",
            (e) => {
              if (!horizontal) return;
              const dx = e.changedTouches[0].clientX - tX;
              if (Math.abs(dx) >= 40) swipeChange(dx);
            },
            { passive: true },
          );

          // Mouse (desktop): pointer events, mouse only so touch isn't handled twice.
          let mX = 0,
            mY = 0,
            mouseDown = false;
          this.productSlider.addEventListener("pointerdown", (e) => {
            if (e.pointerType !== "mouse") return;
            mouseDown = true;
            suppressClick = false;
            mX = e.clientX;
            mY = e.clientY;
          });
          window.addEventListener("pointerup", (e) => {
            if (!mouseDown || e.pointerType !== "mouse") return;
            mouseDown = false;
            const dx = e.clientX - mX,
              dy = e.clientY - mY;
            if (Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy))
              swipeChange(dx);
          });
          this.productSlider.addEventListener(
            "click",
            (e) => {
              if (suppressClick) {
                e.preventDefault();
                e.stopPropagation();
                suppressClick = false;
              }
            },
            true,
          );
        }

        this.productSlider.addEventListener("change", (e) => {
          if (
            this.productGallery.querySelector(
              `.product-gallery-item[data-index="${e.target.index}"]`,
            ).dataset.productMediaType == "model"
          ) {
            if (this.xrButton) {
              this.xrButton.setAttribute(
                "data-shopify-model3d-id",
                this.productGallery.querySelector(
                  `.product-gallery-item[data-index="${e.target.index}"]`,
                ).dataset.mediaId,
              );
            }
            setTimeout(() => {
              this.productSlider
                .querySelector(".css-slider-holder")
                .classList.add("css-slider--disable-dragging");
            }, 150);
          }
        });

        // Parallax

        this.productSlider.addEventListener("ready", (e) => {
          if (this.firstProductGalleryIndex) {
            this.productSlider.changeSlide(
              this.firstProductGalleryIndex,
              "auto",
            );
          }
        });
      }

      // Product variant event listener for theme specific logic

      this.productVariants = this.querySelector(
        "product-variants[data-main-product-variants]",
      );
      if (this.productVariants) {
        this.productVariants.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this),
        );
        this.onVariantChangeHandler({ target: this.productVariants });

        // refresh color
        this.querySelectorAll(".product-variant__item--radio input").forEach(
          (input) => {
            input.addEventListener("click", () => {
              const inputParent = input.closest(
                ".product-variant__item--radio",
              );
              if (
                inputParent.classList.contains("product-variant__item--color")
              ) {
                inputParent
                  .closest(".product-variant")
                  .querySelector(
                    ".product-variant__item-text-label",
                  ).textContent = input.value;
              }
            });
          },
        );
      }

      // show cart drawer when element is added to cart

      if (
        !document.body.classList.contains("template-cart") &&
        KROWN.settings.cart_action == "overlay"
      ) {
        let addToCartEnter = false;
        if (this.querySelector("[data-js-product-add-to-cart]")) {
          this.querySelector("[data-js-product-add-to-cart]").addEventListener(
            "keyup",
            (e) => {
              if (e.keyCode == window.KEYCODES.RETURN) {
                addToCartEnter = true;
              }
            },
          );
        }

        if (this.querySelector("[data-js-product-form]")) {
          this.querySelector("[data-js-product-form]").addEventListener(
            "add-to-cart",
            () => {
              document.getElementById("site-cart-sidebar").show();
              if (document.getElementById("cart-recommendations-sidebar")) {
                document
                  .getElementById("cart-recommendations-sidebar")
                  .generateRecommendations();
              }
              if (addToCartEnter) {
                setTimeout(() => {
                  document
                    .querySelector("#site-cart-sidebar [data-js-close]")
                    .focus();
                }, 200);
              }
            },
          );
        }
      }

      // Check for models

      const models = this.querySelectorAll("product-model");
      if (models.length > 0) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector(".product-gallery__view-in-space");
      }

      // Initialize desktop-only sticky behavior for the main gallery
      try {
        // this._initStickyBehavior();  <-- شفت الشرطتين دول؟ هم دول السر
        console.log("Native sticky active - JS Disabled");
      } catch (e) {
        // fail quietly if something unexpected occurs
        console.warn("Sticky gallery init failed:", e);
      }

      // hide buy now button if stock disabled

      const addToCartButton = this.querySelector(
        "[data-js-product-add-to-cart][data-main-product-add-to-cart]",
      );
      if (addToCartButton) {
        if (addToCartButton.classList.contains("disabled")) {
          this.querySelector("product-form").classList.add(
            "disable-buy-button",
          );
        } else {
          this.querySelector("product-form").classList.remove(
            "disable-buy-button",
          );
        }
        const buyObserver = new MutationObserver(() => {
          if (addToCartButton.classList.contains("disabled")) {
            this.querySelector("product-form").classList.add(
              "disable-buy-button",
            );
          } else {
            this.querySelector("product-form").classList.remove(
              "disable-buy-button",
            );
          }
        });
        buyObserver.observe(addToCartButton, {
          attributes: true,
          childList: false,
          subtree: false,
        });
      }
    }

    goToGalleryImage(index = 0) {
      // Same switch path as a thumbnail click
      this.displayGalleryImage(index);
      if (this.productSlider && this.productSlider.sliderEnabled) {
        this.productSlider.changeSlide(index);
      } else {
        this.thumbnailNavigationHelper(index);
      }
    }

    thumbnailNavigationHelper(index = 0) {
      this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(
        (elm, i) => {
          if (i == index) {
            elm.classList.add("active");
            this.querySelector(".product-gallery__thumbnails-holder").scrollTo({
              left: elm.offsetLeft - 50,
              behavior: "smooth",
            });
          } else {
            elm.classList.remove("active");
          }
        },
      );
    }

    displayGalleryImage(index = 0) {
      // Show the selected image and hide others
      this.productGallery
        .querySelectorAll(".product-gallery-item")
        .forEach((item, i) => {
          if (i == index) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
    }

    // --- Sticky gallery for desktop: keep large image visible while scrolling ---

    _initStickyBehavior() {
      if (!this.productGallery) return;
      // Always use JS sticky implementation for reliable behavior across themes
      this._stickyTopOffset = 20; // px from top when fixed
      // Reuse existing placeholder if it was rendered server-side, otherwise create one
      const prev = this.productGallery.previousElementSibling;
      if (
        prev &&
        prev.classList &&
        prev.classList.contains("product-gallery__sticky-placeholder")
      ) {
        this._stickyPlaceholder = prev;
        this._stickyPlaceholder.style.display = "none";
      } else {
        this._stickyPlaceholder = document.createElement("div");
        this._stickyPlaceholder.className =
          "product-gallery__sticky-placeholder";
        this._stickyPlaceholder.style.display = "none";
        this.productGallery.parentNode.insertBefore(
          this._stickyPlaceholder,
          this.productGallery,
        );
      }
      this._recalcSticky();
      this._onScrollSticky = this._onScrollSticky.bind(this);
      this._onResizeSticky = this._onResizeSticky.bind(this);
      window.addEventListener("scroll", this._onScrollSticky, {
        passive: true,
      });
      window.addEventListener("resize", this._onResizeSticky);
      // run once to set initial state
      this._onScrollSticky();
    }

    _recalcSticky() {
      const galleryRect = this.productGallery.getBoundingClientRect();
      const parentRect = this.productGallery.parentNode.getBoundingClientRect();
      this._originalTop =
        galleryRect.top + (window.scrollY || window.pageYOffset);
      this._originalLeft =
        galleryRect.left + (window.scrollX || window.pageXOffset);
      this._originalWidth = this.productGallery.offsetWidth;
      this._originalHeight = this.productGallery.offsetHeight;
      this._parentTop = parentRect.top + (window.scrollY || window.pageYOffset);
      this._parentHeight = parentRect.height;
      this._stickyHeight = this._originalHeight;
      this._stickyEnabled = window.innerWidth >= 1024;
      this._maxTranslate = Math.max(0, this._parentHeight - this._stickyHeight);
      if (this._stickyPlaceholder) {
        this._stickyPlaceholder.style.width = this._originalWidth + "px";
        this._stickyPlaceholder.style.height = this._originalHeight + "px";
      }
      // if parent is sticky via CSS, override while JS sticky is active
      this._parent = this.productGallery.parentNode;
      this._parentOriginalPosition = this._parent
        ? window.getComputedStyle(this._parent).position
        : "";
      if (this._stickyEnabled && this._parent) {
        this._parent.style.position = "static";
      }
    }

    _onScrollSticky() {
      if (!this._stickyEnabled) {
        this._removeStickyStyles();
        return;
      }
      const scrollY = window.scrollY || window.pageYOffset;
      const containerTop = this._originalTop;
      const containerBottom = this._originalTop + this._originalHeight;
      const fixedStart = containerTop;
      const fixedEnd =
        containerBottom - this._stickyHeight - this._stickyTopOffset;

      // translate the gallery within its parent so it moves down with scrolling
      if (scrollY <= fixedStart) {
        this._removeStickyStyles();
        return;
      }

      // compute desired translate (clamped between 0 and maxTranslate)
      let desired = scrollY - this._parentTop + this._stickyTopOffset;
      desired = Math.max(0, Math.min(desired, this._maxTranslate));
      if (this._stickyPlaceholder)
        this._stickyPlaceholder.style.display = desired > 0 ? "block" : "none";
      this.productGallery.style.willChange = "transform";
      this.productGallery.style.transform = "translateY(" + desired + "px)";
      this.productGallery.style.position = "";
      this.productGallery.style.top = "";
      this.productGallery.style.left = "";
      this.productGallery.style.width = this._originalWidth + "px";
      this.productGallery.style.zIndex = 999;
      return;
    }

    _onResizeSticky() {
      // recompute measurements and re-evaluate
      this._stickyEnabled = window.innerWidth >= 1024;
      this._recalcSticky();
      this._onScrollSticky();
    }

    _removeStickyStyles() {
      if (this._stickyPlaceholder)
        this._stickyPlaceholder.style.display = "none";
      this.productGallery.style.position = "";
      this.productGallery.style.top = "";
      this.productGallery.style.left = "";
      this.productGallery.style.width = "";
      this.productGallery.style.zIndex = "";
    }

    onVariantChangeHandler(e) {
      let variant = e.target.currentVariant;
      if (variant) {
        // image handling

        if (variant.featured_media != null) {
          let variantImg = this.productGallery.querySelector(
            '.product-gallery-item[data-media-id="' +
              variant.featured_media.id +
              '"]',
          );
          if (variantImg) {
            const imageIndex = variantImg.dataset.index;
            // Display the variant image
            this.displayGalleryImage(imageIndex);

            if (
              this.productGallery.classList.contains(
                "product-gallery--slider",
              ) ||
              (this.productGallery.classList.contains(
                "product-gallery--scroll",
              ) &&
                window.innerWidth < 1024)
            ) {
              if (
                this.productGallery.querySelector("css-slider") &&
                this.productGallery.querySelector("css-slider").sliderEnabled
              ) {
                this.productGallery
                  .querySelector("css-slider")
                  .changeSlide(imageIndex);
              } else {
                this.firstProductGalleryIndex = imageIndex;
              }
            } else {
              variantImg.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }
        }

        this.querySelectorAll(
          ".product-variant__item--color [data-selected]",
        ).forEach((elm) => {
          elm
            .closest(".product-variant")
            .querySelector(".product-variant__item-text-label").textContent =
            elm.value;
        });
      }
    }
  }

  if (typeof customElements.get("product-page") == "undefined") {
    customElements.define("product-page", ProductPage);
  }
}
